import { CALL_API } from '../middleware/api'

export const LICENSE_PRO_REQUEST_REQUEST  = 'LICENSE_PRO_REQUEST_REQUEST'
export const LICENSE_PRO_REQUEST_SUCCESS  = 'LICENSE_PRO_REQUEST_SUCCESS'
export const LICENSE_PRO_REQUEST_FAILURE  = 'LICENSE_PRO_REQUEST_FAILURE'
export const LICENSE_PRO_REQUEST_RESET    = 'LICENSE_PRO_REQUEST_RESET'

export const FEATURE_ACTIVATION_REQUEST = 'FEATURE_ACTIVATION_REQUEST'
export const FEATURE_ACTIVATION_SUCCESS = 'FEATURE_ACTIVATION_SUCCESS'
export const FEATURE_ACTIVATION_FAILURE = 'FEATURE_ACTIVATION_FAILURE'
export const FEATURE_ACTIVATION_RESET   = 'FEATURE_ACTIVATION_RESET'

export function requestProUpgrade() {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'license/request-pro',
      authenticated: true,
      types: [
        LICENSE_PRO_REQUEST_REQUEST,
        LICENSE_PRO_REQUEST_SUCCESS,
        LICENSE_PRO_REQUEST_FAILURE,
      ],
    },
  }
}

export function requestFeatureActivation(featureName) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'license/request-feature',
      authenticated: true,
      body: JSON.stringify({ featureName }),
      types: [
        FEATURE_ACTIVATION_REQUEST,
        FEATURE_ACTIVATION_SUCCESS,
        FEATURE_ACTIVATION_FAILURE,
      ],
    },
  }
}

export function resetProUpgrade() {
  return { type: LICENSE_PRO_REQUEST_RESET }
}

export function resetFeatureActivation() {
  return { type: FEATURE_ACTIVATION_RESET }
}
